/**
 * @name LayoutAdmin.js
 * @author 김권영
 * @since 2025. 01. 06.
 * @description
 * 공통 페이지 Layout 
 * 헤더 사이드바 컨텐츠 푸터 형식
 * ----------------------------------------------------------------------------------------
 * 
 */
import React, { useState, useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from './HeaderAdmin';
import Footer from './FooterAdmin';
import Sidebar from './SidebarAdmin';
import './Layout.css';
const LayoutAdmin = ({ children }) => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); 
  const wrapperRef = useRef(null);

  // useEffect(() => {
  //   window.dispatchEvent(new Event('resize'));   // FullCalendar가 updateSize() 실행
  // }, [isSidebarOpen]);

  const openSidebar = (menuId) => {
    if (activeMenu === menuId) {
      // 같은 메뉴를 클릭하면 사이드바 토글
      setIsSidebarOpen(!isSidebarOpen);
      if (isSidebarOpen) {
        setActiveMenu(null);
      }
    } else {
      // 다른 메뉴를 클릭하면 해당 메뉴 활성화 및 사이드바 열기
      setActiveMenu(menuId);
      setIsSidebarOpen(true);
    }
    setTimeout(() => window.dispatchEvent(new Event('resize')), 150);
    
  };
  const closeSidebar = () => {
    setIsSidebarOpen(false);
    setActiveMenu(null);
    setTimeout(() => window.dispatchEvent(new Event('resize')), 150);
  };

  const handleOverlayClick = () => {
    closeSidebar();
  };


  return (
    <>
    <Helmet>
      <link rel="stylesheet" href="/css/admincommon.css" />
      <link rel="stylesheet" href="/css/icon.css" />
    </Helmet>
    <div id="wrapper" ref={wrapperRef} className={isSidebarOpen ? 'sidebar-active' : ''}>
      <Header 
        activeMenu={activeMenu} 
        onMenuSelect={openSidebar} 
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} 
      />


    
      <div id="content-wrapper">
        <Sidebar 
          activeMenu={activeMenu} 
          onMenuSelect={openSidebar} 
          isSidebarOpen={isSidebarOpen} 
          closeSidebar={closeSidebar} 
        />
        <div className="content">
          <div className="container-fluid">
            {isSidebarOpen &&  <div className="overlay" onClick={handleOverlayClick} />}  
            {children}
          </div>
        </div>
      </div>

      {/* <Footer />  */}
      
    </div>
    </>
  );
};

export default LayoutAdmin;
